import { Box, Stack, Typography } from "@mui/material";
import { SvgContainer } from "../../../components";
import theme from "../../../theme/theme";

interface Props {
  title: string;
  subTitle: string | number;
  icon: any;
  iconColor: string;
}

function DashboardTopCard({ title, subTitle, icon, iconColor }: Props) {
  return (
    <Stack
      direction={"row"}
      alignItems="center"
      sx={{
        backgroundColor: "white",
        borderRadius: 2,
        p: 2,
        py: 3,
        position: "relative",
        boxShadow: "0px 4px 4px rgba(139, 139, 139, 0.05)",
      }}
    >
      <Box
        sx={{
          width: 3,
          height: "70%",
          backgroundColor: iconColor,
          position: "absolute",
          left: 0,
          top: "15%",
        }}
      />
      <Stack
        sx={{
          backgroundColor: iconColor + "30",
          width: 47,
          height: 47,
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 100,
          mr: 1.5,
        }}
      >
        <SvgContainer svg={icon} color={iconColor} />
      </Stack>
      <Box>
        <Typography color={theme.colors.black} fontWeight={550}>{title}</Typography>
        <Typography color="#3D423F" fontSize={12}>
          Total: {subTitle}
        </Typography>
      </Box>
    </Stack>
  );
}

export default DashboardTopCard;
